<template>
  <section class="releaseDetailDiv">
    <section class="viewTitle">
      <viewTitle
        :title="
          type === 'appoint'
            ? '业务管理 / 车辆预约管理 / 预约记录管理 / 查看预约详情'
            : '业务管理 / 车辆安全放行 / 货车放行 / 查看车辆详情'
        "
        :showReturn="true"
      />
    </section>

    <section class="p16">
      <!-- 模块一 -->
      <section>
        <div class="title">
          <div class="tag"></div>
          <span class="text">预约信息</span>
        </div>
        <div class="content">
          <el-row :gutter="20">
            <el-col :span="10">运输单位：{{ info.unit }}</el-col>
            <el-col :span="7">办理业务：{{ business.name }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <span v-if="business.type === 1">产品线：</span>
              <span v-if="business.type === 0">业务子类：</span>
              {{ business_products_name.join("、") || "--" }}
            </el-col>
            <el-col :span="7">车牌号：{{ info.license_plate || "--" }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              车辆类型：<span v-if="Number(info.vehicle_type) === 1"
                >平板车</span
              >
              <span v-if="Number(info.vehicle_type) === 2">货柜车</span>
              <span v-if="Number(info.vehicle_type) === 3">槽罐车</span>
              <span v-if="Number(info.vehicle_type) === 4">其他</span>
              <span v-if="Number(info.vehicle_type) === 5">高栏车</span>
            </el-col>
            <el-col :span="7">司机姓名：{{ info.name || "--" }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">手机号码：{{ info.contact || "--" }}</el-col>
            <el-col :span="7">身份证号：{{ info.id_card || "--" }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              预约类型：
              <span
                style="color: #FFB134;"
                v-if="Number(rowDataObj.type) === 2"
              >
                应急预约
              </span>
              <span style="color: #008b5e;" v-else>
                普通预约
              </span>
            </el-col>
            <el-col :span="7"
              >预约到厂时间：{{ formatBookingTime(rowDataObj.booking_day) }}
              {{ `${booking_time.begin_time}至${booking_time.end_time}` }}
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6"
              >身份证正反面：
              <div v-if="src.length > 0">
                <imagePlus
                  class="cardimg"
                  :src="src[0]"
                  fit="cover"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
                <imagePlus
                  class="cardimg"
                  :src="src[1]"
                  fit="cover"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
              </div>
            </el-col>
            <el-col :span="6"
              >驾驶证主副页：
              <div v-if="src.length > 0">
                <imagePlus
                  class="cardimg"
                  :src="src[2]"
                  fit="cover"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
                <imagePlus
                  class="cardimg"
                  :src="src[3]"
                  fit="cover"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
              </div>
            </el-col>
            <el-col :span="6"
              >行驶证主副页：
              <div v-if="src.length > 0">
                <imagePlus
                  class="cardimg"
                  :src="src[4]"
                  fit="cover"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
                <imagePlus
                  class="cardimg"
                  :src="src[5]"
                  fit="cover"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="type === 'appoint'">
            预约状态：
            <span class="color5E">
              {{ appointStateOption[rowDataObj.state] }}
            </span>
          </el-row>
        </div>
      </section>

      <!-- 模块二 -->
      <section v-if="report === null && type === 'appoint'"></section>
      <section style="padding-top: 10px;" v-else>
        <div class="title">
          <div class="tag"></div>
          <span class="text">报到信息</span>
        </div>
        <!-- 不可操作 未报到1，报到失效3，已关闭7，已失效6 -->
        <div
          class="content"
          v-if="
            String(rowDataObj.state) === '1' ||
              String(rowDataObj.state) === '3' ||
              String(rowDataObj.state) === '6' ||
              String(rowDataObj.state) === '7'
          "
        >
          <el-row>
            <el-col style="font-size: 16px;"
              >安全状态：
              <span class="color67" v-if="String(rowDataObj.state) === '1'">
                不可操作（司机未报到，请让司机先完成报到）。
              </span>
              <span class="color67" v-if="String(rowDataObj.state) === '3'">
                不可操作（司机的报到已失效，请让司机重新报到）。
              </span>
              <span class="color67" v-if="String(rowDataObj.state) === '6'">
                不可操作（本次预约已失效，请让司机重新预约）。
              </span>
              <span class="color67" v-if="String(rowDataObj.state) === '7'">
                不可操作（本次预约已被管理员关闭，请让司机重新预约）。
              </span>
            </el-col>
          </el-row>
        </div>
        <div class="content" v-else>
          <el-row>
            <el-col>
              报到时间：<span>{{ formatTime(report.report_time) }}</span>
              <!-- v-if="isLate" -->
              <div class="tips">
                <i
                  class="el-icon-warning"
                  style="color: #EC3F67"
                  v-if="isLate"
                ></i>
                {{
                  lateTime(
                    rowDataObj.booking_day,
                    booking_time.begin_time,
                    booking_time.end_time,
                    report.report_time
                  )
                }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              >司机姓名：{{ report_info.name || "--" }}
              <div
                class="tips"
                v-if="
                  info.name &&
                    report_info.name &&
                    info.name.trim() !== report_info.name.trim()
                "
              >
                <i class="el-icon-warning" style="color: #EC3F67"></i>
                与预约信息不一致
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              >身份证号：{{ report_info.id_card || "--" }}
              <div
                class="tips"
                v-if="
                  info.id_card &&
                    report_info.id_card &&
                    info.id_card.trim() !== report_info.id_card.trim()
                "
              >
                <i class="el-icon-warning" style="color: #EC3F67"></i>
                与预约信息不一致
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              >手机号码：{{ report_info.contact || "--" }}
              <div
                class="tips"
                v-if="
                  info.contact &&
                    report_info.contact &&
                    info.contact.trim() !== report_info.contact.trim()
                "
              >
                <i class="el-icon-warning" style="color: #EC3F67"></i>
                与预约信息不一致
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="display: flex;">
              <div class="tbTitle">
                随行人员：
              </div>
              <div style="flex: 19;">
                <div
                  class="tbCell"
                  v-for="(item, index) in report_entourage"
                  :key="index"
                >
                  <div class="cellLeft">
                    随行人员
                  </div>
                  <div class="cellRight">
                    <div class="left">姓名：</div>
                    <div class="right">{{ item.name }}</div>
                  </div>
                  <div class="cellRight">
                    <div class="left">身份证：</div>
                    <div class="right">{{ item.id_card }}</div>
                  </div>
                  <div class="cellRight">
                    <div class="left">手机号码：</div>
                    <div class="right">{{ item.contact }}</div>
                  </div>
                </div>
                <div v-if="String(report_entourage) === 'undefined'">--</div>
                <div v-else-if="report_entourage.length === 0">--</div>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="type !== 'appoint'">
            <el-col style="font-size: 16px;"
              >安全状态：
              <span
                :class="
                  report.state === 2 || report.state === 4 || report.state === 7
                    ? 'color5E'
                    : 'color67'
                "
                v-if="String(report) !== 'undefined'"
              >
                <template
                  v-if="
                    tarpaulin_comment_car_type &&
                      String(rowDataObj.tarpaulin_state) === '0' &&
                      String(rowDataObj.state) === '4'
                  "
                >
                  <span class="color67">
                    不可操作（司机未确认篷布防护，请让司机确认后再离厂）。
                  </span>
                </template>
                <template v-else>
                  {{ stateOption[Number(report.state) - 1] }}
                </template>
              </span>
            </el-col>
          </el-row>
        </div>
      </section>

      <!-- 补充 模块三 -->
      <section
        v-if="queue.length > 0 && type === 'appoint'"
        style="padding-top: 10px;"
      >
        <div class="title">
          <div class="tag"></div>
          <span class="text">排队信息</span>
        </div>
        <div class="content">
          <el-row>
            <el-col>
              进厂时间：{{ formatTime(report.into_factory_time) }}
            </el-col>
          </el-row>
          <el-row>
            <el-col style="display: flex;">
              <div class="tbTitle">
                详细信息：
              </div>
              <div style="flex: 19;">
                <div class="tbCell" v-for="(item, index) in queue" :key="index">
                  <div class="cellLeft">
                    排队信息
                  </div>
                  <div class="cellRight">
                    <div class="left">产品线：</div>
                    <div class="right">{{ item.business_name }}</div>
                  </div>
                  <div class="cellRight">
                    <div class="left">排队编号：</div>
                    <div class="right">
                      {{ `${item.code}` === "" ? "--" : `${item.code}` }}
                    </div>
                  </div>
                  <div class="cellRight">
                    <div class="left">当前状态：</div>
                    <div class="right">
                      {{
                        Number(item.loading_state) === 0
                          ? `${queueState[item.queue_state]}`
                          : `${loadState[item.loading_state]}`
                      }}
                    </div>
                  </div>
                  <div class="cellRight">
                    <div class="left">当前排位：</div>
                    <div class="right">
                      <span
                        v-if="
                          Number(item.loading_state) === 0 &&
                            Number(item.queue_state) === 1
                        "
                      >
                        第{{ item.ranking }}位
                      </span>
                      <span v-else>--</span>
                    </div>
                  </div>
                </div>
                <div v-if="String(queue) === 'undefined' || queue.length === 0">
                  --
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>

      <!-- 模块四 -->
      <section v-if="poundData.pound.length > 0" style="padding-top: 10px;">
        <div class="title">
          <div class="tag"></div>
          <span class="text">过磅信息</span>
        </div>
        <div class="content">
          <div class="poundMain">
            <table>
              <tr>
                <td class="bgf7 tr fwb tdt1">预约单号:</td>
                <td colspan="2" class="bgf7 tl">
                  <template v-if="poundData.id && poundData.id.length > 0">{{
                    poundData.id
                  }}</template>
                  <template v-else>--</template>
                </td>
                <td class="bgf7 tr tdt2 fwb">车牌号:</td>
                <td class="bgf7 tl">
                  <template
                    v-if="
                      poundData.license_plate &&
                        poundData.license_plate.length > 0
                    "
                    >{{ poundData.license_plate }}</template
                  >
                  <template v-else>--</template>
                </td>
                <td class="bgf7 tr tdt2 fwb">办理业务:</td>
                <td class="bgf7 tl">
                  <template
                    v-if="
                      poundData.main_business.name &&
                        poundData.main_business.name.length > 0
                    "
                    >{{ poundData.main_business.name }}</template
                  >
                  <template v-else>--</template>
                </td>
                <td class="bgf7 tr tdt2 fwb">业务类型:</td>
                <td class="bgf7 tl">{{ subBusinessName }}</td>
              </tr>
              <tr>
                <td colspan="9" class="bgf7 tac fwb">
                  共{{ poundData.pound.length }}个料品，已验收<span class="s1"
                    >{{ checkNumber }}个
                  </span>
                </td>
              </tr>
              <template v-for="(item, index) in poundData.pound">
                <tr :key="index + 'tr1'">
                  <td rowspan="4" class="bgf7 tac fwb">
                    {{ item.receipt_number }}
                  </td>
                  <td class="tr tdt2 fwb">入库单号:</td>
                  <td class="tl">
                    <template
                      v-if="
                        item.receipt_number && item.receipt_number.length > 0
                      "
                    >
                      {{ item.receipt_number }}
                    </template>
                    <template v-else>--</template>
                  </td>
                  <td class="tr tdt2 fwb">物料编号:</td>
                  <td class="tl">
                    <template
                      v-if="
                        item.inventory_code && item.inventory_code.length > 0
                      "
                    >
                      {{ item.inventory_code }}
                    </template>
                    <template v-else>--</template>
                  </td>
                  <td class="tr tdt2 fwb">物料名称:</td>
                  <td class="tl">
                    <template
                      v-if="
                        item.inventory_name && item.inventory_name.length > 0
                      "
                    >
                      {{ item.inventory_name }}
                    </template>
                    <template v-else>--</template>
                  </td>
                  <td class="tr tdt2 fwb">计量单位:</td>
                  <td class="tl">
                    <template
                      v-if="
                        item.inventory_unit && item.inventory_unit.length > 0
                      "
                    >
                      {{ item.inventory_unit }}
                    </template>
                    <template v-else>--</template>
                  </td>
                </tr>
                <tr :key="index + 'tr2'">
                  <td class="tr tdt2 fwb">毛重:</td>
                  <td class="tl">
                    {{ item.rough_weight }} {{ item.inventory_unit }}
                  </td>
                  <td class="tr tdt2 fwb">皮重:</td>
                  <td class="tl">
                    {{ item.tare_weight }} {{ item.inventory_unit }}
                  </td>
                  <td class="tr tdt2 fwb">静重:</td>
                  <td class="tl">
                    {{ item.net_weight }} {{ item.inventory_unit }}
                  </td>
                  <td class="tr tdt2 fwb">收货仓库:</td>
                  <td class="tl">
                    <template
                      v-if="
                        item.warehouse_name && item.warehouse_name.length > 0
                      "
                    >
                      {{ item.warehouse_name }}
                    </template>
                    <template v-else>--</template>
                  </td>
                </tr>
                <tr :key="index + 'tr3'">
                  <td class="tr tdt2 fwb">入场时间:</td>
                  <td class="tl tdti">
                    {{ entryTime(item.entry_time) }}
                  </td>
                  <td class="tr tdt2 fwb">入库时间:</td>
                  <td class="tl tdti">
                    {{ entryTime(item.entry_warehouse_time) }}
                  </td>
                  <td class="tr tdt2 fwb">地磅操作人:</td>
                  <td class="tl">
                    <template
                      v-if="item.receiver_name && item.receiver_name.length > 0"
                    >
                      {{ item.receiver_name }}
                    </template>
                    <template v-else>--</template>
                  </td>
                  <td class="tr tdt2 fwb">验收状态:</td>
                  <td :class="item.state == 1 ? 'tl state1' : 'tl state2'">
                    {{ poundState(item.state) }}
                  </td>
                </tr>
                <tr :key="index + 'tr4'">
                  <td class="tr tdt2 fwb">验收人:</td>
                  <td class="tl">
                    <template
                      v-if="
                        item.acceptance_user_name &&
                          item.acceptance_user_name.length > 0
                      "
                    >
                      {{ item.acceptance_user_name }}
                    </template>
                    <template v-else>--</template>
                  </td>
                  <td class="tr tdt2 fwb">验收时间:</td>
                  <td class="tl tdti">
                    {{ acceptanceTime(item.acceptance_time) }}
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr
                  :key="index + 'tr5'"
                  v-if="index != poundData.pound.length - 1"
                >
                  <td colspan="9"></td>
                </tr>
              </template>
            </table>
          </div>
        </div>
      </section>

      <!-- 模块五 -->
      <section>
        <div class="timeLine">
          <div class="timeBlock">
            <div class="title">进厂前</div>
            <el-timeline id="firstTimeline">
              <el-timeline-item
                v-for="(activity, index) in activities1"
                :key="index"
                :icon="activity.icon"
                :type="activity.type"
                :color="activity.color"
                :size="activity.size"
                :timestamp="activity.timestamp"
              >
                <!-- {{ activity.content }} -->
                <div v-html="activity.content"></div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="timeBlock" v-if="String(report) !== 'undefined'">
            <div class="title">进厂后</div>
            <el-timeline id="secondTimeline">
              <el-timeline-item
                v-for="(activity, index) in activities2"
                :key="index"
                :icon="activity.icon"
                :type="activity.type"
                :color="activity.color"
                :size="activity.size"
                :timestamp="activity.timestamp"
              >
                <!-- {{ activity.content }} -->
                <template v-if="Number(activity.is_evaluate) === 1">
                  <el-popover
                    :ref="'popoverevaluate' + index"
                    placement="top-start"
                    :width="
                      activity.evaluateData.operator_type == 2 ? '400' : '330'
                    "
                    :visible="activity.evaluateData.visible"
                    trigger="click"
                  >
                    <template>
                      <p
                        style=" font-size: 16px; margin: 0; padding: 0 0 5px 0; font-size: large;"
                      >
                        查看篷布防护详情
                      </p>
                      <el-form
                        :label-width="
                          activity.evaluateData.operator_type == 2
                            ? '170px'
                            : '100px'
                        "
                        class="evaluateFrom"
                      >
                        <el-form-item label="由谁盖篷布：">
                          <span>{{ activity.evaluateData.userName }}</span>
                        </el-form-item>
                        <el-form-item
                          v-if="activity.evaluateData.operator_type == 1"
                          label="服务评分："
                        >
                          <el-rate
                            v-model="activity.evaluateData.val"
                            disabled
                            show-score
                            :text-color="activity.evaluateData.color"
                            :score-template="activity.evaluateData.text"
                          >
                          </el-rate>
                        </el-form-item>
                        <el-form-item
                          v-if="activity.evaluateData.operator_type == 2"
                          label="自行做篷布防护的原因："
                        >
                          <span
                            style="white-space: pre-wrap;"
                            v-html="activity.evaluateData.self_reason"
                          ></span>
                        </el-form-item>
                        <el-form-item label="意见反馈：">
                          <span
                            v-if="activity.evaluateData.content.length > 0"
                            style="white-space: pre-wrap;"
                            v-html="activity.evaluateData.content"
                          ></span>
                          <span v-else>--</span>
                        </el-form-item>
                        <el-form-item label="提交时间：">
                          <span>{{ activity.timestamp }}</span>
                        </el-form-item>
                        <el-form-item label="">
                          <div style="text-align: right;">
                            <el-button
                              slot="reference"
                              size="small"
                              @click="hideEvaluateData(index)"
                              >关闭</el-button
                            >
                          </div>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-popover>
                  <div>
                    <span
                      style=" cursor: pointer;"
                      @click="
                        activity.evaluateData.visible = !activity.evaluateData
                          .visible
                      "
                      v-popover="'popoverevaluate' + index"
                      v-html="activity.content"
                    ></span>
                  </div>
                </template>
                <template v-else>
                  <div v-html="activity.content"></div>
                </template>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </section>

      <section>
        <div v-if="type === 'appoint'">
          <div
            style="margin-top: 30px;display: inline-block;"
            v-if="rowDataObj.state !== 7"
          >
            <el-popover
              style="margin-right: 20px;"
              placement="bottom-start"
              :title="popParams.title"
              width="370"
              trigger="manual"
              v-model="popParams.visibleClose"
            >
              <template>
                <p>
                  确认要关闭“<span class="color67">{{
                    info.license_plate
                  }}</span
                  >”于<span class="color67"
                    >{{ formatBookingTime(rowDataObj.booking_day) }}
                    {{
                      `${booking_time.begin_time}至${booking_time.end_time}`
                    }}</span
                  >的预约记录吗？
                  <br />
                  <span class="color67">关闭后不可恢复！</span>
                </p>
                <div style="text-align: right; margin: 34px 0px 0px;">
                  <el-button
                    slot="reference"
                    size="small"
                    @click="popParams.visibleClose = false"
                    >取 消</el-button
                  >
                  <el-button type="primary" size="small" @click="confirmClose"
                    >确 定</el-button
                  >
                </div>
              </template>
              <el-button
                slot="reference"
                type="danger"
                style="color: #fff;"
                size="small"
                @click="popParams.visibleClose = !popParams.visibleClose"
                >关闭预约</el-button
              >
            </el-popover>
          </div>
        </div>
        <!-- 不可操作（未报到1，报到失效3，已关闭7，已失效6）  放行，拒绝  不可点击 -->
        <div
          style="margin-top: 30px;display: inline-block;"
          v-else-if="
            rowDataObj.state === 1 ||
              rowDataObj.state === 3 ||
              rowDataObj.state === 6 ||
              rowDataObj.state === 7
          "
        >
          <el-button disabled type="info" style="color: #fff;" size="small"
            >放行进厂</el-button
          >
          <el-button disabled type="info" style="color: #fff;" size="small"
            >拒绝进厂</el-button
          >
        </div>
        <!-- 不可操作 （可离厂4） && （未盖雨篷布tarpaulin_state为1） 放行离厂，拒绝离厂 不可点击-->
        <div
          style="margin-top: 30px;display: inline-block;"
          v-else-if="
            tarpaulin_comment_car_type &&
              Number(rowDataObj.state) === 4 &&
              Number(rowDataObj.tarpaulin_state) === 0
          "
        >
          <el-button disabled type="info" style="color: #fff;" size="small"
            >放行离厂</el-button
          >
          <el-button disabled type="info" style="color: #fff;" size="small"
            >拒绝离厂</el-button
          >
        </div>
        <!-- 其它可操作情况 -->
        <!-- 正常状态  可进厂2 不可进厂1  放行，拒绝；  已拒绝进厂 3 放行；  可离厂 4 放行离厂 -->
        <!-- 放行进厂（正常，非正常）  放行离厂  拒绝进厂  拒绝离厂  关闭预约 -->
        <div v-else>
          <div
            style="margin-top: 30px;display: inline-block;"
            v-if="String(report) !== 'undefined' && report.state === 2"
          >
            <el-popover
              style="margin-right: 20px;"
              placement="bottom-start"
              :title="popParams.title"
              width="370"
              trigger="manual"
              v-model="popParams.visibleNormalIn"
            >
              <template>
                <!-- 放行进厂 （正常状态）-->
                <p>
                  确认要放行“<span class="color67">{{
                    info.license_plate
                  }}</span
                  >”<span class="color67">进厂</span>吗？
                </p>
                <div style="line-height: 25px;margin-bottom: 10px;">
                  <el-checkbox-group v-model="popParams.checkList">
                    <el-checkbox label="0" style="width: 100%;">
                      我已认真核实司机及随行人员的防疫轨迹，体温均正常。
                    </el-checkbox>
                    <el-checkbox label="1" style="width: 100%;">
                      我已认真核实司机及随行人员与报到信息完全一致。
                    </el-checkbox>
                    <el-checkbox label="2" style="width: 100%;">
                      我已认真核实司机及车牌号与预约信息完全一致。
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div>
                  选择门口<span class="color67">*</span>
                  <el-select
                    v-model="popParams.gateValue"
                    placeholder="请选择"
                    style="width: 116px;margin: 0px 15px;"
                    @change="confirmSelectGate"
                  >
                    <el-option
                      v-for="item in gateOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span class="color67">{{ popParams.gateReleaseTips }}</span>
                </div>
                <div
                  style="display: flex;align-items: flex-start; padding-top:15px;"
                >
                  <span
                    style="display: inline-block; width:92px; text-align: right;padding-right: 20px; box-sizing: border-box;"
                    >备注</span
                  >
                  <el-input
                    type="textarea"
                    :rows="3"
                    resize="none"
                    placeholder="请输入备注"
                    v-model="popParams.remarks"
                  >
                  </el-input>
                </div>
                <div style="text-align: right; margin: 34px 0px 0px;">
                  <el-button
                    slot="reference"
                    size="small"
                    @click="popParams.visibleNormalIn = false"
                    >取 消</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    @click.stop="confirmRelease"
                    >确 定</el-button
                  >
                </div>
              </template>
              <el-button
                slot="reference"
                type="primary"
                size="small"
                @click="popParams.visibleNormalIn = !popParams.visibleNormalIn"
                >放行进厂</el-button
              >
              <!-- @click="popParams.show = true" -->
            </el-popover>
          </div>

          <div
            style="margin-top: 30px;display: inline-block;"
            v-if="
              String(report) !== 'undefined' &&
                (report.state === 1 || report.state === 3)
            "
          >
            <el-popover
              style="margin-right: 20px;"
              placement="bottom-start"
              :title="popParams.title"
              width="370"
              trigger="manual"
              v-model="popParams.visibleAbNormalIn"
            >
              <template>
                <!-- 放行进厂 （非正常状态）-->
                <p>
                  “<span class="color67">{{ info.license_plate }}</span
                  >”处于<span class="color67">{{
                    report.state === 1 ? "不可进厂" : "已拒绝进厂"
                  }}</span
                  >状态，确认放行吗？
                </p>
                <div style="line-height: 25px;margin-bottom: 10px;">
                  <el-checkbox-group v-model="popParams.checkList">
                    <el-checkbox label="0" style="width: 100%;">
                      我已认真核实司机及随行人员的防疫轨迹，体温均正常。
                    </el-checkbox>
                    <el-checkbox label="1" style="width: 100%;">
                      我已认真核实司机及随行人员与报到信息完全一致。
                    </el-checkbox>
                    <el-checkbox label="2" style="width: 100%;">
                      我已认真核实司机及车牌号与预约信息完全一致。
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div>
                  选择门口<span class="color67">*</span>
                  <el-select
                    v-model="popParams.gateValue"
                    placeholder="请选择"
                    style="width: 116px;margin: 0px 15px;"
                    @change="confirmSelectGate"
                  >
                    <el-option
                      v-for="item in gateOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span class="color67">{{ popParams.gateReleaseTips }}</span>
                </div>
                <div style="display: flex;align-items: flex-start;">
                  <div style="margin-top: 18px;">
                    放行理由<span class="color67">*</span>
                  </div>
                  <el-radio-group
                    v-model="popParams.releaseReason"
                    style="margin: 20px 0px 0px 17px;"
                  >
                    <el-radio :label="'早到'">早到</el-radio>
                    <el-radio :label="'晚到'">晚到</el-radio>
                    <el-radio :label="'其他'">其他</el-radio>
                  </el-radio-group>
                  <!-- <el-input
                    style="width: 165px; margin: 18px 15px 0px;"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入放行理由"
                    v-model="popParams.releaseReason"
                    @input="confirmReason"
                  >
                  </el-input> -->
                </div>
                <div class="color67" style="margin: 10px 0px 0px 80px;">
                  {{ popParams.gateReasonTips }}
                </div>
                <div
                  style="display: flex;align-items: flex-start; padding-top:15px;"
                >
                  <span
                    style="display: inline-block; width:92px; text-align: right;padding-right: 20px; box-sizing: border-box;"
                    >备注</span
                  >
                  <el-input
                    type="textarea"
                    :rows="3"
                    resize="none"
                    placeholder="请输入备注"
                    v-model="popParams.remarks"
                  >
                  </el-input>
                </div>
                <div style="text-align: right; margin: 34px 0px 0px;">
                  <el-button
                    slot="reference"
                    size="small"
                    @click="popParams.visibleAbNormalIn = false"
                    >取 消</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    @click.stop="confirmRelease"
                    >确 定</el-button
                  >
                </div>
              </template>
              <el-button
                slot="reference"
                type="primary"
                size="small"
                @click="
                  popParams.visibleAbNormalIn = !popParams.visibleAbNormalIn
                "
                >放行进厂</el-button
              >
              <!-- @click="popParams.show = true" -->
            </el-popover>
          </div>

          <!-- report.state = 4 放行离厂 -->
          <div
            style="margin-top: 30px;display: inline-block;"
            v-if="
              String(report) !== 'undefined' &&
                (report.state === 4 || report.state === 6)
            "
          >
            <el-popover
              style="margin-right: 20px;"
              placement="bottom-start"
              :title="popParams.title"
              width="370"
              trigger="manual"
              v-model="popParams.visibleGo"
            >
              <template>
                <!-- 放行离厂 -->
                <div style="line-height: 25px;margin-bottom: 10px;">
                  确定要放行“<span class="color67">{{
                    info.license_plate
                  }}</span
                  >”离厂吗？
                </div>
                <div>
                  选择门口<span class="color67">*</span>
                  <el-select
                    v-model="popParams.gateValue"
                    placeholder="请选择"
                    style="width: 116px;margin: 0px 15px;"
                    @change="confirmSelectGate"
                  >
                    <el-option
                      v-for="item in gateOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span class="color67">{{ popParams.gateReleaseTips }}</span>
                </div>
                <div
                  style="display: flex;align-items: flex-start; padding-top:15px;"
                >
                  <span
                    style="display: inline-block; width:92px; text-align: right;padding-right: 20px; box-sizing: border-box;"
                    >备注</span
                  >
                  <el-input
                    type="textarea"
                    :rows="3"
                    resize="none"
                    placeholder="请输入备注"
                    v-model="popParams.remarks"
                  >
                  </el-input>
                </div>
                <div style="text-align: right; margin: 34px 0px 0px;">
                  <el-button
                    slot="reference"
                    size="small"
                    @click="popParams.visibleGo = false"
                    >取 消</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    @click.stop="confirmReleaseGo"
                    >确 定</el-button
                  >
                </div>
              </template>
              <el-button
                slot="reference"
                type="primary"
                size="small"
                @click="popParams.visibleGo = !popParams.visibleGo"
                >放行离厂</el-button
              >
              <!-- @click="popParams.show = true" -->
            </el-popover>
          </div>

          <div
            style="margin-top: 30px;display: inline-block;"
            v-if="
              String(report) !== 'undefined' &&
                (report.state === 1 || report.state === 2)
            "
          >
            <el-popover
              style="margin-right: 20px;"
              placement="bottom-start"
              :title="popParams.title"
              width="370"
              trigger="manual"
              v-model="popParams.visibleRejectIn"
            >
              <template>
                <!-- 拒绝进厂-->
                <p>
                  确认要<span class="color67"
                    >拒绝放行“{{ info.license_plate }}”进厂</span
                  >吗？
                </p>
                <div style="text-align: right; margin: 34px 0px 0px;">
                  <el-button
                    slot="reference"
                    size="small"
                    @click="popParams.visibleRejectIn = false"
                    >取 消</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    @click.stop="confirmReject"
                    >确 定</el-button
                  >
                </div>
              </template>
              <el-button
                slot="reference"
                type="danger"
                size="small"
                style="color: #fff;"
                @click="popParams.visibleRejectIn = !popParams.visibleRejectIn"
                >拒绝进厂</el-button
              >
              <!-- @click="popParams.show = true" -->
            </el-popover>
          </div>

          <div
            style="margin-top: 30px;display: inline-block;"
            v-if="String(report) !== 'undefined' && report.state === 4"
          >
            <el-popover
              style="margin-right: 20px;"
              placement="bottom-start"
              :title="popParams.title"
              width="370"
              trigger="manual"
              v-model="popParams.visibleRejectGo"
            >
              <template>
                <!-- 拒绝离厂-->
                <p>
                  确认要<span class="color67"
                    >拒绝放行“{{ info.license_plate }}”离厂</span
                  >吗？
                </p>
                <div style="text-align: right; margin: 34px 0px 0px;">
                  <el-button
                    size="small"
                    slot="reference"
                    @click="popParams.visibleRejectGo = false"
                    >取 消</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    @click.stop="confirmRejectGo"
                    >确 定</el-button
                  >
                </div>
              </template>
              <el-button
                slot="reference"
                type="danger"
                size="small"
                style="color: #fff;"
                @click="popParams.visibleRejectGo = !popParams.visibleRejectGo"
                >拒绝离厂</el-button
              >
              <!-- @click.stop="popParams.show = true" -->
            </el-popover>
          </div>
          <!-- 
        <div
          style="margin-top: 30px;display: inline-block;"
          v-if="popParams.popoverReleaseSuccess"
        >
          <el-popover
            style="margin-right: 20px;"
            placement="bottom-start"
            title="操作成功"
            width="370"
          >
            <template> -->
          <!-- 拒绝进厂-->
          <!-- <p>
                <span class="color67">“{{ info.license_plate }}”</span
                >已放行，状态变更为<span class="color5E">可离厂</span>
              </p>
              <div style="text-align: right; margin: 34px 0px 0px;">
                <el-button type="primary" size="mini">我知道了</el-button>
              </div>
            </template>
          </el-popover>
        </div> -->

          <el-dialog
            :visible.sync="popParams.popoverReleaseSuccess"
            width="30%"
          >
            <template slot="title">
              <div style="font-size: 18px;">
                <i class="el-icon-success" style="color: #2acdcf;"></i>
                操作成功
              </div>
            </template>
            <div>
              <div v-html="popParams.popoverSuccessContent"></div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button
                @click="popParams.popoverReleaseSuccess = false"
                size="small"
              >
                我知道了
              </el-button>
            </span>
          </el-dialog>
        </div>
      </section>

      <el-dialog
        :visible.sync="popParams.popoverReleaseSuccess"
        width="30%"
        title="操作成功"
      >
        <div>
          <div v-html="popParams.popoverSuccessContent"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="popParams.popoverReleaseSuccess = false"
            size="small"
          >
            我知道了
          </el-button>
        </span>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import moment from "moment";
import viewTitle from "@/components/viewTitle";
import imagePlus from "@/components/elementPlus/packages/image/index.js";
export default {
  data() {
    return {
      params: {
        keyword: "", // 关键字搜索
        name: "珠海坚力运输有限公司",
        remark: "成品提货"
      },
      popParams: {
        status: 1,
        popoverControlRelease: false, // 选择门口（可进厂状态）
        popoverConReAbnormal: false, // 选择门口（不可进厂状态）
        popoverReleaseSuccess: false, //放行成功
        popoverAppoint: false, // 关闭预约
        popoverCloseAppoint: false, // 关闭预约成功
        title: "确认提醒",
        show: false,
        license: "粤C80390",
        gateValue: "", // 放行进厂门口信息
        resonValue: "", // 放行理由信息
        gateReleaseTips: "", // 放行进厂选择门口提示
        gateReasonTips: "", // 理由填写提示
        releaseReason: "", // 放行理由
        checkList: [], // 防疫选项
        popoverSuccessContent: "",
        visibleNormalIn: false, // 正常放行进厂
        visibleAbNormalIn: false, // 非正常放行进厂
        visibleGo: false, // 放行离厂
        visibleRejectGo: false, // 拒绝离厂
        visibleRejectIn: false, // 拒绝进厂
        visibleClose: false, // 关闭预约
        remarks: "" //备注
      },
      rowDataObj: {}, // obj
      business_products: {}, // 产品线
      business_products_name: [], // 产品线名称
      business: {}, // 业务
      booking_time: {}, // 预约时间
      info: {}, // 预约信息
      file: {}, // 预约文件
      report: {}, // 报到
      report_info: {}, // 报到信息
      report_entourage: {}, // 随行人员
      log: {}, // 日志
      queue: {}, // 排队信息
      src: [],
      srcList: [],
      activities1: [],
      activities2: [],
      gateOptions: [],
      isLate: false,
      stateOption: [
        "不可进厂",
        "可进厂",
        "已拒绝进厂",
        "可离厂",
        "不可离厂",
        "已拒绝离厂",
        "已离厂"
      ], // 安全状态(report.state)
      appointStateOption: [
        "",
        "未报到",
        "已报到",
        "报到失效",
        "业务办理中",
        "已挂起",
        "已失效",
        "已关闭",
        "已完成",
        "已拒绝"
      ],
      queueState: [
        "",
        "排队中",
        "叫号中",
        "已过号",
        "已失效",
        "已完成",
        "已终止"
      ],
      loadState: [
        "未开始",
        "等待装货",
        "拒绝装货",
        "装货中",
        "装货完成",
        "已完成",
        "已终止"
      ],
      releaseDetailInterval: null, // 1分钟请求接口，用于保持页面不会登录超时
      imgChangeList: [],
      poundData: { main_business: {}, sub_business: [], pound: [] }, // 过磅消息数据
      tarpaulin_comment: {} // 盖篷布评价信息
    };
  },

  components: {
    viewTitle,
    imagePlus
  },

  mounted() {
    this.getDetail();
    this.getGateList();
    this.getPoundData();
    setTimeout(() => {
      // 1分钟定时刷新，保持页面不会登录超时
      this.releaseDetailInterval = window.setInterval(() => {
        this.keepLogin();
      }, 1000 * 60);
    }, 1000 * 60);
  },

  async activated() {},

  created() {},

  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.releaseDetailInterval);
    next();
  },

  methods: {
    imagePreHide() {
      console.log(this.imgChangeList);
      this.imgChangeList.forEach(async (RotateItem, index) => {
        if (RotateItem != 0) {
          let id = this.rowDataObj.file[index].id;
          let real_path = this.rowDataObj.file[index].real_path;
          await this.$common
            .http({
              url: "/api/queue/admin/update_booking_info_file",
              data: {
                id: id,
                url: real_path,
                rotate_degrees: RotateItem
              },
              noLoading: true
            })
            .then(res => {
              let real_path = res.data.data;
              let file = this.rowDataObj.file[index];
              file.real_path = real_path;
              this.$set(this.rowDataObj.file, index, file);
              this.$set(this.src, index, real_path);
              this.$set(this.srcList, index, real_path);
            });
        }
      });
      for (let i = 0; i < this.imgChangeList.length; i++) {
        this.imgChangeList[i] = 0;
      }
    },
    imageRotateDeg(items, num, index) {
      console.log("請求旋轉圖片接口", items, num, index);
      this.imgChangeList[index] = this.imgChangeList[index] + (0 - num);
      console.log(this.imgChangeList);
    },
    // 保持页面不会登录超时
    keepLogin() {
      this.$common
        .http({
          url: "/api/permission/list_mine",
          data: {},
          noLoading: true,
          method: "GET"
        })
        .then(() => {});
    },

    // 获取详情
    async getDetail() {
      this.activities1 = [];
      this.activities2 = [];
      this.business_products_name = [];
      await this.$common
        .http({
          url: "/api/queue/admin/query_booking_detail",
          data: {
            booking_info_id: this.id
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.rowDataObj = res.data.data;
          this.business_products = this.rowDataObj.business.sub_business; // 产品线
          this.business = this.rowDataObj.business; // 业务
          this.booking_time = this.rowDataObj.booking_time; // 预约时间
          this.info = this.rowDataObj.info; // 预约信息
          this.file = this.rowDataObj.file; // 预约文件
          this.report = this.rowDataObj.report; // 报到
          this.report_info = this.rowDataObj.report_info; // 报到信息
          this.report_entourage = this.rowDataObj.report_entourage; // 随行人员
          this.log = this.rowDataObj.log; // 日志
          this.queue = this.rowDataObj.queue; // 排队信息
          this.tarpaulin_comment = this.rowDataObj.tarpaulin_comment || {}; //盖篷布评价信息
          let rateArray = ["非常不满意", "不满意", "一般", "满意", "非常满意"];
          for (let i = 0; i < this.log.length; i++) {
            if (this.log[i].type === 0) {
              this.activities1.push({
                content: this.log[i].note,
                timestamp: this.formatTime(this.log[i].create_time),
                color: "#229A73"
              });
            } else {
              if (Number(this.log[i].event_type) === 33) {
                this.activities2.push({
                  content: this.log[i].note,
                  timestamp: this.formatTime(this.log[i].create_time),
                  color: "#00c8d2",
                  evaluateData: {
                    operator_type: this.tarpaulin_comment.operator_type,
                    userName:
                      Number(this.tarpaulin_comment.operator_type) === 1
                        ? "现场工作人员"
                        : "自己",
                    val: Number(this.tarpaulin_comment.score),
                    color: "#ff9900",
                    text: rateArray[Number(this.tarpaulin_comment.score) - 1],
                    content: this.tarpaulin_comment.feedback,
                    self_reason: this.tarpaulin_comment.self_reason,
                    visible: false
                  },
                  is_evaluate: 1
                });
              } else {
                this.activities2.push({
                  content: this.log[i].note,
                  timestamp: this.formatTime(this.log[i].create_time),
                  color: "#00c8d2"
                });
              }
            }
          }
          // 照片
          this.imgChangeList = [];
          for (let i = 0; i < this.file.length; i++) {
            this.imgChangeList.push(0);
            this.src.splice(
              Number(this.file[i].type),
              0,
              this.file[i].real_path
            );
          }
          this.srcList = this.src;
          // this.rowDataObj.state = 7;
          // this.report.state = 2;
          this.popParams.status = this.report === null ? "" : this.report.state;
          // 产品线名称数组
          this.business_products.forEach(item => {
            this.business_products_name.push(item.name);
          });
        });
    },

    // 获取门口列表
    async getGateList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_door",
        data: {
          keyword: "",
          state: 1,
          page_size: 0
        }
      });
      this.gateOptions = dataObj.data.data;
      let value = localStorage.getItem("gateValue");
      for (let i = 0; i < this.gateOptions.length; i++) {
        if (this.gateOptions[i].id === value) {
          this.popParams.gateValue = value;
        }
      }
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 格式化实例时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    // 计算迟到时间
    lateTime(bookingDay, bookingBeginTime, bookingEndTime, reportTime) {
      let str1 = String(bookingDay);
      let str2 = `${str1.substring(0, 4)}-${str1.substring(
        4,
        6
      )}-${str1.substring(6, 8)} ${bookingEndTime}`;
      let str3 = `${str1.substring(0, 4)}-${str1.substring(
        4,
        6
      )}-${str1.substring(6, 8)} ${bookingBeginTime}`;
      // 迟到
      if (reportTime - moment(str2, "YYYY-MM-DD HH:mm").unix() > 0) {
        let min = (reportTime - moment(str2, "YYYY-MM-DD HH:mm").unix()) / 60;
        if (min > 60) {
          this.isLate = true;
          return `迟到大于1小时(${Math.floor(min)}分钟)`;
        } else {
          this.isLate = false;
        }
      }
      // 提前
      if (moment(str3, "YYYY-MM-DD HH:mm").unix() - reportTime > 0) {
        let min = (moment(str3, "YYYY-MM-DD HH:mm").unix() - reportTime) / 60;
        if (min > 60) {
          this.isLate = true;
          return `提前到厂大于1小时(${Math.floor(min)}分钟)`;
        } else {
          this.isLate = false;
        }
      }
    },

    // 确认放行进厂
    confirmRelease() {
      if (this.popParams.checkList.length < 3) {
        this.$common.pcToastFail("请确认并勾选相关信息");
        return false;
      }
      if (this.popParams.gateValue === "") {
        this.popParams.gateReleaseTips = "请选择门口！";
        return false;
      }
      if (
        this.popParams.releaseReason.trim() === "" &&
        (this.popParams.status === 1 || this.popParams.status === 3)
      ) {
        // this.popParams.gateReasonTips = "请选择放行理由！";
        this.$common.pcToastFail("请选择放行理由！");
        return false;
      }
      this.$common
        .http({
          url: "/api/queue/admin/operate_report",
          data: {
            report_id: this.rowDataObj.report.id,
            state: 4,
            through_reason: this.popParams.releaseReason,
            door_id: this.popParams.gateValue,
            remarks: this.popParams.remarks
          }
        })
        .then(res => {
          console.log(res);
          // this.report.state = 4;
          this.popParams.show = false;
          this.popParams.popoverSuccessContent = `“<span class="color67">${this.info.license_plate}</span>”已成功放行进厂！`;
          this.popParams.popoverReleaseSuccess = true;
          this.emptyData();
          this.getDetail();
        });
    },

    // 确定放行离厂
    confirmReleaseGo() {
      if (this.popParams.gateValue === "") {
        this.popParams.gateReleaseTips = "请选择门口！";
        return false;
      }
      this.$common
        .http({
          url: "/api/queue/admin/operate_report",
          data: {
            report_id: this.rowDataObj.report.id,
            state: 7,
            through_reason: "",
            door_id: this.popParams.gateValue,
            remarks: this.popParams.remarks
          }
        })
        .then(res => {
          console.log(res);
          // this.report.state = 7;
          this.popParams.show = false;
          this.popParams.popoverSuccessContent = `“<span class="color67">${this.info.license_plate}</span>”已放行，状态变更为“<span class="color5E">已离厂</span>”`;
          this.popParams.popoverReleaseSuccess = true;
          this.emptyData();
          this.getDetail();
          // setTimeout(() => {
          //   this.popParams.popoverReleaseSuccess = false
          // }, 1500);
        });
    },

    // 确定拒绝进厂
    confirmReject() {
      this.$common
        .http({
          url: "/api/queue/admin/operate_report",
          data: {
            report_id: this.rowDataObj.report.id,
            state: 3,
            through_reason: this.popParams.releaseReason,
            door_id: this.popParams.gateValue
          }
        })
        .then(res => {
          console.log(res);
          // this.report.state = 3;
          this.popParams.popoverSuccessContent = `“<span class="color67">${this.info.license_plate}</span>”已被拒绝放行，状态变更为“<span class="color67">已拒绝进厂</span>”`;
          this.popParams.popoverReleaseSuccess = true;
          this.emptyData();
          this.getDetail();
          // setTimeout(() => {
          //   this.popParams.popoverReleaseSuccess = false
          // }, 1500);
        });
    },

    // 确定拒绝离厂
    confirmRejectGo() {
      this.$common
        .http({
          url: "/api/queue/admin/operate_report",
          data: {
            report_id: this.rowDataObj.report.id,
            state: 6,
            through_reason: this.popParams.releaseReason,
            door_id: this.popParams.gateValue
          }
        })
        .then(res => {
          console.log(res);
          // this.report.state = 6;
          this.popParams.popoverSuccessContent = `“<span class="color67">${this.info.license_plate}</span>”已被拒绝离厂，状态变更为“<span class="color67">已拒绝离厂</span>”`;
          this.popParams.popoverReleaseSuccess = true;
          this.emptyData();
          this.getDetail();
          // setTimeout(() => {
          //   this.popParams.popoverReleaseSuccess = false
          // }, 1500);
        });
    },

    // 关闭预约
    confirmClose() {
      // this.popParams.show = true;
      // this.popParams.popoverAppoint = true;
      // this.popParams.popoverCloseAppoint = false;
      this.$common
        .http({
          url: "/api/queue/admin/close_booking",
          data: {
            booking_id: this.booking_id
          }
        })
        .then(res => {
          console.log(res);
          // this.rowDataObj.state = 7;
          this.popParams.popoverSuccessContent = `已关闭“<span class="color67">
          ${this.info.license_plate}
          </span>”于“<span class="color67">
          ${this.formatBookingTime(this.rowDataObj.booking_day)}
          ${this.booking_time.begin_time}
          至
          ${this.booking_time.end_time}
          </span>”的预约记录！`;
          this.popParams.popoverReleaseSuccess = true;
          this.emptyData();
          this.getDetail();
          // setTimeout(() => {
          //   this.popParams.popoverReleaseSuccess = false
          // }, 1500);
        });
    },

    // 清空数据
    emptyData() {
      // 清空数据
      // this.popParams.gateValue = ""; // 放行进厂门口信息
      this.popParams.resonValue = ""; // 放行理由信息
      this.popParams.gateReleaseTips = ""; // 放行进厂选择门口提示
      this.popParams.gateReasonTips = ""; // 理由填写提示
      this.popParams.releaseReason = ""; // 放行理由
      this.popParams.remarks = ""; // 备注
      this.popParams.checkList = []; // 防疫选项
      // 重置提示显示
      this.popParams.visibleNormalIn = false;
      this.popParams.visibleAbNormalIn = false;
      this.popParams.visibleGo = false;
      this.popParams.visibleRejectGo = false;
      this.popParams.visibleRejectIn = false;
      this.popParams.visibleClose = false;
    },

    // 选择门口
    confirmSelectGate(val) {
      console.log(val);
      this.popParams.gateReleaseTips = "";
      localStorage.setItem("gateValue", val);
    },

    // 填写理由
    confirmReason(val) {
      console.log(val);
      if (val.trim() !== "") {
        this.popParams.gateReasonTips = "";
      }
    },

    // 获取地磅消息
    getPoundData() {
      if (this.booking_id == undefined || this.booking_id.length == 0) {
        return;
      }
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_pound",
          data: {
            booking_id: this.booking_id
          }
        })
        .then(res => {
          this.poundData = res.data.data;
          // this.poundData = {
          //   id: "0ea8e8dad61349479f7e33b286e5102a",
          //   license_plate: "宁978944",
          //   main_business: {
          //     id: "6b659440f6ec4d8a8d94881718b963be",
          //     name: "华丰厂-成品出厂",
          //     type: 1
          //   },
          //   sub_business: [
          //     {
          //       id: "f03dd425a2db4f0bb0de10e87b401b13",
          //       name: "4成品出厂-子",
          //       type: 1
          //     }
          //   ],
          //   pound: [
          //     {
          //       id: "a9ac3a821d7249f3aec6a46249fdd33a",
          //       booking_id: "0ea8e8dad61349479f7e33b286e5102a",
          //       create_time: 1608708019,
          //       update_time: 1608708019,
          //       info_state: 1,
          //       license_plate: "宁978944",
          //       receipt_number: "0000000440",
          //       warehouse_name: "TSW原料仓",
          //       entry_warehouse_time: "2020-12-23 00:00:00.000",
          //       rough_weight: 50,
          //       tare_weight: 20,
          //       net_weight: 30,
          //       receiver_name: "0000000440",
          //       entry_time: "2020-12-23 15:17:15.693",
          //       inventory_code: "1010-00000-008",
          //       inventory_name: "测试自由",
          //       inventory_unit: "pcs",
          //       state: 0,
          //       acceptance_time: 0,
          //       acceptance_user_id: "",
          //       acceptance_user_name: null
          //     }
          //   ]
          // };
        });
    },
    hideEvaluateData() {
      document.getElementsByTagName("body")[0].click();
    }
  },

  computed: {
    type() {
      return this.$route.query.type;
    },
    id() {
      return this.$route.query.id;
    },
    booking_id() {
      return this.$route.query.booking_id;
    },
    indexText() {
      return index => {
        if (Number(index) < 10) {
          return "0" + (index + 1).toString();
        } else {
          return index;
        }
      };
    },
    checkNumber() {
      let num = 0;
      this.poundData.pound.forEach(element => {
        if (Number(element.state) == 1) {
          num++;
        }
      });
      return num;
    },
    entryTime() {
      return t => {
        if (t.length > 0) {
          return moment(t).format("YYYY年MM月DD日 HH:mm:ss");
        } else {
          return "--";
        }
      };
    },
    acceptanceTime() {
      return t => {
        if (Number(t) > 0) {
          return moment.unix(t).format("YYYY年MM月DD日 HH:mm:ss");
        } else {
          return "--";
        }
      };
    },
    poundState() {
      return val => {
        let text = "";
        if (val == 0) {
          text = "未验收";
        }
        if (val == 1) {
          text = "已验收";
        }
        return text;
      };
    },
    subBusinessName() {
      let sub_business = "";
      this.poundData.sub_business.forEach((element, index) => {
        sub_business = sub_business + element.name;
        if (index != this.poundData.sub_business.length - 1) {
          sub_business = sub_business + ";";
        }
      });
      if (sub_business.length == 0) {
        sub_business = "--";
      }
      return sub_business;
    },
    tarpaulin_comment_car_type() {
      if (Number(this.info.vehicle_type) === 1) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.releaseDetailDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding: 20px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }

  .title {
    & > .tag {
      display: inline-block;
      height: 21px;
      background: #00a0fa;
      width: 5px;
      margin-right: 7px;
      vertical-align: bottom;
    }
    & > .text {
      font-size: 18px;
      color: #333333;
      font-weight: bold;
    }
  }

  .content {
    margin: 16px 11px;
    font-size: 14px;
    color: #333;
    line-height: 30px;
    .cardimg {
      width: 90px;
      height: 56px;
      margin-top: 7px;
      margin-right: 17px;
    }
    .tips {
      display: inline-block;
      margin-left: 10px;
      font-size: 11px;
      color: #ec3f67;
    }
    // 随行人员
    .tbTitle {
      display: inline-block;
      vertical-align: top;
    }
    .tbCell {
      display: inline-block;
      text-align: center;
      margin: 8px 20px 10px 0px;
      & > .cellLeft {
        width: 280px;
        line-height: 35px;
        font-size: 16px;
        background: rgb(247, 247, 247);
        border-radius: 4px 4px 0px 0px;
      }
      & > .cellRight {
        display: flex;
        font-size: 12px;
        & > .left {
          flex: 1.2;
          border: 1px solid #f7f7f7;
          text-align: right;
          padding: 0px 8px 0px 0px;
        }
        & > .right {
          flex: 2;
          border: 1px solid #f7f7f7;
          border-left: 0px;
          text-align: left;
          padding: 0px 0px 0px 15px;
        }
      }
    }
  }
  // 时间线
  .timeLine {
    display: flex;
    margin-top: 30px;
    & > .timeBlock {
      padding: 0px 35px;
      background: #f2f9f7;
      margin-right: 20px;
      width: 360px;
      & > .title {
        text-align: center;
        line-height: 56px;
        font-feature-settings: 18px;
      }
    }
  }

  .el-image__inner {
    object-fit: cover;
  }

  .poundMain {
    display: inline-block;
    max-height: 420px;
    overflow: auto;
    table {
      border-collapse: collapse;
    }
    td {
      border: 1px solid #e7e7e7;
      padding: 3px;
      vertical-align: middle;
    }
    .tl {
      text-align: left;
    }
    .tr {
      text-align: right;
    }
    .tac {
      text-align: center;
    }
    .fwb {
      font-weight: bold;
    }
    .bgf7 {
      background: #f7f7f7;
    }
    .tdt1 {
      width: 90px;
    }
    .tdt2 {
      width: 80px;
    }
    .tdti {
      width: 165px;
    }
    .state1 {
      color: #00c8d2 !important;
    }
    .state2 {
      color: #f56c6c !important;
    }
  }
}
</style>
<style lang="less">
.el-popover {
  .evaluateFrom {
    max-height: 450px;
    overflow: auto;
    padding-right: 10px;
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        color: #999999;
      }
      .el-rate {
        padding-top: 9px;
      }
      .el-form-item__content,
      .el-form-item__label {
        line-height: 30px;
      }
    }
    .el-rate__text {
      font-size: 12px;
    }
  }
}
</style>
